import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideQueryService } from 'src/app/core/services/query.service';
import { PSA_ENDPOINT, psaSingleStateConfig, psaStateConfig } from '../psa/psa.config';
import { PsaService } from '../psa/psa.service';
import {  Psa, PsaState } from '../psa/psa.model';
import { InitializeStore } from 'src/app/shared/functions/store.functions';


@NgModule({
  declarations: [],
  providers: [
    ...provideQueryService<Psa>(PSA_ENDPOINT, psaStateConfig),
    PsaService,
    //da togliere
    ...InitializeStore<PsaState>('psa-store', psaSingleStateConfig),
  ],
  imports: [
    CommonModule,
  ],
})
export class DashboardModule { }